// This is just an example,
// so you can safely delete all default props below

export default {
    email: 'Email (as written on your ticket)',
    booking_number: 'Booking Number',
    find: 'Find Order',
    order_time: 'Order Time',
    total: 'Total',
    status: 'Status',
    select: 'Select Departure',
    cancelled: 'Cancelled',
    cancel_selected: 'Cancel Selected Trips',
    error_booking_number: 'Booking number is required',
    error_email: 'Email is required',
    error_order_not_found: 'We could not find a ticket for the information provided, check the ticket number and/or email address if it is written correctly, and try again.',
    error_trip_selection: 'Trip to cancel must be selected',
    failed: 'Cancellation failed',
    success: 'Cancellation success',
    error_cancellation_time_passed: 'The departure time has passed, cancellation can not be completed'
}
